import { defineStore } from 'pinia'
import router from '../router'

export interface AuthUser {
  id: number
  username: string
  email: string
  role_id: number
  role_name: string
  permissions: string[]
}

export const useUserStore = defineStore('user', {
  state: () => ({
    user: JSON.parse(localStorage.getItem('user') || 'null') as AuthUser | null,
    token: localStorage.getItem('token') || null,
  }),

  getters: {
    isAuthenticated: (state) => !!state.token,
    isAdmin: (state) => state.user?.role_name === 'admin',
    permissions: (state) => state.user?.permissions || [],
    hasPermission: (state) => (perm: string) => state.user?.permissions?.includes(perm) || false,
  },

  actions: {
    async login(username: string, password: string) {
      try {
        const response = await fetch('/inv/auth/login', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username, password }),
        })

        const data = await response.json()

        if (data.success) {
          this.token = data.data.token
          this.user = data.data.user
          if (this.token) localStorage.setItem('token', this.token)
          localStorage.setItem('user', JSON.stringify(this.user))
          return { success: true }
        }

        return { success: false, error: data.error?.message || 'Invalid credentials' }
      } catch (error) {
        console.error('Login failed:', error)
        return { success: false, error: 'Connection error' }
      }
    },

    async fetchMe() {
      if (!this.token) return
      try {
        const response = await fetch('/inv/auth/me', {
          headers: { Authorization: `Bearer ${this.token}` },
        })
        if (response.status === 401) {
          this.logout()
          if (router.currentRoute.value.path !== '/login') {
            router.push('/login')
          }
          return
        }
        const data = await response.json()
        if (data.success) {
          this.user = data.data
          localStorage.setItem('user', JSON.stringify(this.user))
        }
      } catch (error) {
        console.error('Fetch me failed:', error)
      }
    },

    logout() {
      this.user = null
      this.token = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    },
  },
})
